<template>
  <a-popover trigger="click" placement="bottomRight">
    <template slot="content">
      <a-spin :spinning="loadding">
        <a-tabs>
          <a-tab-pane tab="通知" key="1">
            <a-list>
              <a-list-item>
                <a-list-item-meta
                  title="你收到了 14 份新周报"
                  description="一年前"
                >
                  <a-avatar
                    style="background-color: white"
                    slot="avatar"
                    src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"
                  />
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta
                  title="你推荐的 曲妮妮 已通过第三轮考试"
                  description="一年前"
                >
                  <a-avatar
                    style="background-color: white"
                    slot="avatar"
                    src="https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png"
                  />
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta
                  title="欢迎访问我们的系统"
                  description="一年前"
                >
                  <a-avatar
                    style="background-color: white"
                    slot="avatar"
                    src="https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png"
                  />
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-tab-pane>
          <a-tab-pane tab="消息" key="2">
            开学报到注意事项
          </a-tab-pane>
          <a-tab-pane tab="待办" key="3">
            关于开展校园消防演练的注意事项
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice">
      <a-badge count="12">
        <a-icon :class="['header-notice-icon', theme]" type="bell" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
export default {
  name: 'HeaderNotice',
  data() {
    return {
      loadding: false
    };
  },
  computed: {
    theme() {
      return this.$store.state.setting.layout === 'side'
        ? 'light'
        : this.$store.state.setting.theme;
    }
  },
  methods: {
    fetchNotice() {
      if (this.loadding) {
        this.loadding = false;
        return;
      }
      this.loadding = true;
      setTimeout(() => {
        this.loadding = false;
      }, 2000);
    }
  }
};
</script>

<style lang="stylus">
.header-notice
  display inline-block
  transition all 0.3s
  span
    vertical-align initial
  .header-notice-icon
    font-size 16px
    padding 4px
    &.dark
      color #fff
    &.light
      color rgba(0, 0, 0, 0.65)
</style>
